
import React from 'react';
import { Button } from '@/components/ui/button';
import { User } from '@supabase/supabase-js';

interface DashboardHeaderProps {
  user: User | null;
}

export function DashboardHeader({ user }: DashboardHeaderProps) {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8">
      <div>
        <h1 className="text-3xl font-bold text-grandpal-green mb-2">My Dashboard</h1>
        <p className="text-gray-600">
          Welcome back, {user?.user_metadata?.first_name || 'there'}! Manage your nursing home search process.
        </p>
      </div>
      
      <div className="mt-4 md:mt-0 space-x-2">
        <Button asChild variant="outline">
          <a href="/waitlist">Update Preferences</a>
        </Button>
        <Button asChild className="bg-grandpal-green hover:bg-grandpal-green/90">
          <a href="/nursing-homes">Explore Homes</a>
        </Button>
      </div>
    </div>
  );
}
